import * as types from "./withdrawalActionTypes";
import api from "./withdrawalApi";

export function clear(model) {
  return {
    type: types.CLEAR,
    model,
  };
}

export function request(model, item, customHeaders, options, query) {
  return {
    type: types.FETCH,
    model,
    promise: api.request(model, item, customHeaders, options, query),
    payload: { model },
  };
}

export function withdraw(model, item, customHeaders, options, query) {
  return {
    type: types.WITHDRAW,
    model,
    promise: api.request(model, item, customHeaders, options, query),
  };
}



// WEBPACK FOOTER //
// ./src/components/withdrawal/withdrawalActions.js